import React, { useEffect } from "react";
import isEqual from "react-fast-compare";
import { getSimplifiedKeywordForGoogle } from "../../../../../redux/constants/commandCenterConstants";
import moment from "moment";
const GoogleTrend = ({
  widget_id,
  params,
  type,
  keyword,
  region,
  className,
  isTwitterTrend = false,
}) => {
  useEffect(() => {
    try {
      if (params) {
        const selectedKeyword = isTwitterTrend
          ? keyword === undefined && params?.searchText
            ? getSimplifiedKeywordForGoogle(params?.searchText)
            : getSimplifiedKeywordForGoogle(params?.keyword || keyword)
          : params?.keyword || keyword; // params?.keyword;
        let startDate = moment(params?.startDate, "YYYY/MM/DD HH:mm")?.format(
          "MMM Do YY"
        );
        let endDate = moment(params?.endDate, "YYYY/MM/DD HH:mm")?.format(
          "MMM Do YY"
        );

        const region = ""; //params?.region;
        const tz = params?.timeOffset;

        if (
          moment(params?.endDate, "YYYY/MM/DD HH:mm")?.diff(
            moment(params?.startDate, "YYYY/MM/DD HH:mm"),
            "hours"
          ) <=
          7 * 24
        ) {
          startDate = "now";
          endDate = "7-d";
        } else {
          startDate = "today";
          endDate = "1-m";
        }
        if (window?.trends && window?.trends?.embed) {
          window?.trends?.embed?.renderExploreWidgetTo(
            document?.getElementById(`widget-${widget_id}-${type}`),
            type,
            {
              comparisonItem: [
                {
                  keyword: selectedKeyword,
                  geo: region,
                  time: `${startDate} ${endDate}`,
                },
              ],
              category: 0,
              property: "",
            },
            {
              exploreQuery: `tz=${tz}&eq=q=${encodeURIComponent(
                selectedKeyword
              )}&geo=${region}&date="${startDate} ${endDate}"`,
              guestPath: "https://trends.google.com:443/trends/embed/",
            }
          );
        }
      }
    } catch (error) {
      console.error(
        "Error while generating Google Trend : for ",
        `widget-${widget_id}-${type}`
      );
    }
  }, [type, keyword, region, params]);

  return (
    <div
      className={`GoogleTrend ${
        className ? className : ""
      } border-0 border-radius-4`}
    >
      <div id={`widget-${widget_id}-${type}`}></div>
    </div>
  );
};
export default React.memo(GoogleTrend, isEqual);
